import type from "../types/actionTypes";

const initialState = {
};

export default function categoryReducers(state = initialState, action) {
    switch (action.type) {
        case type.GET_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.data.categories
            }
        case type.GET_CATEGORIES_ERROR:
            return {
                ...state,
                message: action.error
            }
        default:
            return state;
    }
}